import React from "react";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { StyledH2, StyledLabel, StyledModal } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";

import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

export default function ConfirmationModal({
    setIsAutoFill,
    isModalOpened,
    setIsModalOpened,
    setIsEdited,
    getFetch,
}: any) {
    const { t } = useTranslation();

    return (
        <StyledModal
            isOpen={isModalOpened}
            centered
            className="supportCode__clz"
        >
            <ModalHeader
                className="text-capitalize mnt_icn_close"
                toggle={() => setIsModalOpened(false)}
            >
                <StyledH2>{t("Confirmation")}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel>
                    {t(
                        "Attention: Activating autofill will lead to the loss of data already entered."
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => setIsModalOpened(false)}
                    rounded
                    className="mnt_btn_cancelAlert"
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsAutoFill(true);
                        setIsEdited(true);
                        setIsModalOpened(false);
                        getFetch();
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
